import { DayOfWeek } from "./dayOfWeek";
import { Drinks } from "./drinks";

export type DrinkingDay = Record<Drinks, number>;

export const initialDrinkingDay = {
  beer: 0,
  pint: 0,
  wine: 0,
  spirit: 0
};

export const initialDrinkerType = {
  drinkerType: "never"
};

export interface DrinksWithTotal extends DrinkingDay {
  amount: number;
}

export interface DrinksTotals extends DrinkingDay {
  beer: number;
  pint: number;
  wine: number;
  spirit: number;
}

export interface DrinkerType {
  drinkerType: string;
}

export interface DrinksPerDay extends DrinksWithTotal {
  day: DayOfWeek;
}

export interface UnitAndCalories {
  calories: number;
  units: number;
}

export const emptyUnitAndCalories: UnitAndCalories = {
  calories: 0,
  units: 0
};

export interface UnitsAndCaloriesPerDay extends UnitAndCalories {
  day: DayOfWeek;
}
